import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import RiskCalculator from './components/RiskCalculator';
import SanctionsTable from './components/SanctionsTable';
import LatestPostsCarousel from './components/LatestPostsCarousel';
import ContactSection from './components/ContactSection';
import CTASection from './components/CTASection';
import EbookSection from './components/EbookSection';
import CookieBanner from './components/CookieBanner';
import ChatWidget from './components/ChatWidget';
import ProtocoloPage from './pages/ProtocoloPage';
import FAQPage from './pages/FAQPage';
import BlogPage from './pages/BlogPage';
import AdminChatPage from './pages/AdminChatPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminArticlesPage from './pages/AdminArticlesPage';
import ArticlePage from './pages/ArticlePage';
import PrivacidadPage from './pages/legal/PrivacidadPage';
import CookiesPage from './pages/legal/CookiesPage';
import AvisoLegalPage from './pages/legal/AvisoLegalPage';
import TransparenciaIAPage from './pages/legal/TransparenciaIAPage';
import ChecklistPage from './pages/ChecklistPage';
import ExitIntentPopup from './components/ExitIntentPopup';
import './App.css';

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    const scrollTarget = location.hash?.replace('#', '') || location.state?.scrollTo;
    if (scrollTarget) {
      setTimeout(() => {
        const element = document.getElementById(scrollTarget);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="home-page">
      <Header />
      <main>
        <HeroSection />
        <RiskCalculator />
        <SanctionsTable />
        <LatestPostsCarousel />
        <EbookSection />
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/protocolo" element={<ProtocoloPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<ArticlePage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/chat" element={<AdminChatPage />} />
          <Route path="/admin/articles" element={<AdminArticlesPage />} />
          <Route path="/checklist-plazos" element={<ChecklistPage />} />
          <Route path="/legal/privacidad" element={<PrivacidadPage />} />
          <Route path="/legal/cookies" element={<CookiesPage />} />
          <Route path="/legal/aviso-legal" element={<AvisoLegalPage />} />
          <Route path="/legal/transparencia-ia" element={<TransparenciaIAPage />} />
        </Routes>
        <CookieBanner />
        <ExitIntentPopup />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
